'use client';
import { jsx } from 'react/jsx-runtime';
import { useSwanI18nContext } from '../../contexts/i18n/swan-i18n-provider.context.js';
import { Button } from '../button/button.component.js';
import { renderWithRef } from '../core/render-with-ref.js';
import { RenderComp } from '../core/render-comp.component.js';

function _object_without_properties(e, r) {
    if (null == e) return {};
    var t, o, i = _object_without_properties_loose(e, r);
    if (Object.getOwnPropertySymbols) {
        var n = Object.getOwnPropertySymbols(e);
        for(o = 0; o < n.length; o++)t = n[o], !(r.indexOf(t) >= 0) && Object.prototype.propertyIsEnumerable.call(e, t) && (i[t] = e[t]);
    }
    return i;
}
function _object_without_properties_loose(e, r) {
    if (null == e) return {};
    var t, o, i = {}, n = Object.keys(e);
    for(o = 0; o < n.length; o++)t = n[o], r.indexOf(t) >= 0 || (i[t] = e[t]);
    return i;
}
const AdaptiveCarouselSlidePickerInternal = renderWithRef('AdaptiveCarouselSlidePickerInternal', null, (t, n)=>{
    let { closestPage: a, goToSlide: l, pages: s } = t, c = _object_without_properties(t, [
        "closestPage",
        "goToSlide",
        "pages"
    ]), { t: p } = useSwanI18nContext();
    return jsx(RenderComp, {
        root: "div",
        forwardedRef: n,
        classNames: new Set([
            'swan-adaptive-carousel-slide-picker-internal'
        ]),
        props: c,
        children: s.map((r)=>jsx(Button, {
                className: "swan-adaptive-carousel-slide-picker-internal-button",
                "aria-current": r === a,
                onClick: ()=>l(r),
                skin: "unstyled",
                "aria-label": p('adaptive-carousel-slide-picker-internal.accessible-text-for-button', {
                    slideNumber: r
                })
            }, r))
    });
});

export { AdaptiveCarouselSlidePickerInternal };
